let defaultConfig;

const config = {
  hostURL: `${window.location.protocol}//${window.location.host}/piction/`,
  cardURL: `${window.location.protocol}//${window.location.host}`,
  initialQuery: false,
  baseSearchWord: false,
  externalLogin: false,
  useUserDefinedConfig: true,
  disableRightClick: false,
  useZoomify: true,
  useWebQualityForSmallThumb: true,
  umoExternalLink: false,
  umoTitleMetatag: false,
  umoDisplayTitleAboveImage: false,
  showTitleOverGalleryUmo: true,
  discovererEditMode: false,
  setSchemaName: false,
  restrictEditing: false,
  allowCollectionEdit: false,
  allowIndividualMetaEdit: true,
  enableCopyUMOs: false,
  collapseCategories: false,
  categoriesSortByCC: false,
  dateFormat: 'dd-MMM-yyyy',
  inProgressNotifications: false,
  categoryCounts: false,
  enableGlobalCategoryCreation: false,
  enableUmoCompare: false,
  enableLinkShare: false,
  enableMultiLang: false,
  removeEmptyMetatags: false,
  usePopupForDownloads: false,
  tombstoneCharacterLimit: 50,
  alternateReps: false,
  autoExpandMetaSchema: false,
  useHighlights: false,
  removeHomeButton: false,
  removeWorkspaces: false,
  removeCategories: false,
  removeWorkspaceCardView: false,
  useCustomKAUI2Conf: false,
  addExternalButton: false,
  alternateMaxRows: 50,
  tabTitle: false,
  removeLogoutBtn: false,
  navExternalLink: false,
  logoLink: false,
  reportImage: true,
  listViewMetatags: false,
  listViewRemoveMediaData: false,
  listViewIncludeTombstoneData: false,
  displayNavBarLabels: false,
  alternateExcRelational: false,
  showLanguageSelection: false,
  openWorkflowDashboardExternally: false,
  enableSortCategory: false,
  portalShareUsername: false,
  portalShareEmail: 'KAUI2.Portal_Email',
  downloadPurposeFields: false,
  sortItemMetatag: false,
  umoGallery: {
    filesWithNoPreview: [],
    gridViewDefault: true,
    umosPerPage: 25,
    sortByOptions: [
      {
        value: 'D',
        label: 'Date loaded',
        default: true,
        isDescending: false,
      },
    ],
    filterByOptions: [
      { type: 'dateRange' },
      { type: 'metatag', category: 'PICTION EXAMPLE', name: 'LIST OF VALUES' },
      {
        type: 'metatag',
        category: 'PICTION EXAMPLE',
        name: 'OPTIONAL CHECKBOX',
      },
      { type: 'metatag', category: 'PICTION EXAMPLE', name: 'BOOLEAN' },
    ],
    showCategoryUploadButton: true,
  },
  umoRatings: {
    display: true,
    complex: false,
    overrideMetatag: false,
  },
  customClassMetatag: '',
  customClassMetatagAllowEmptyValues: true,
  thesaurus: {
    show: false,
    mainLabel: 'Projects',
    id: 6548525,
  },
  excelExportMetatags: false,
  pptExportMetatags: false,
  imageDerivIndexForPPT: false,
  videoOriginalIndexForWeb: '2',
  audioOriginalIndexForWeb: '2',
  templates: {
    basket: {
      name: 'KAUI2.BASKET',
      label: 'Usage Clearance',
      labelLocale: { en: 'Usage Clearance', fr: 'FR Usage Clearance' },
      maxUMOsPerBasket: false,
    },
    photoBasket: {
      name: 'KAUI2.PHOTOBASKET',
      label: 'Photography Request',
      labelLocale: { en: 'Photography Request', fr: 'FR Photography Request' },
      maxUMOsPerBasket: false,
    },
    authoriseWorkflow: {
      name: 'KAUI2.Authorisation',
      label: 'Authorise Request',
      labelLocale: { en: 'Authorise Request', fr: 'FR Authorise Request' },
    },
    workflowDashboard: {
      name: 'JOB.Login_Page_Workbench',
      label: 'Workflow Dashboard',
      labelLocale: { en: 'Workflow Dashboard', fr: 'FR Workflow Dashboard' },
    },
  },
  menuOptions: {
    adminMenu: [
      'auth',
      'metaAttach',
      'workflowDash',
      'usersAndRoles',
      'manageCategoryRoles',
      'publish',
      'newRelational',
      'loader',
      'importMetadata',
      'recycleBin',
    ],
    umoMenu: [
      'editMetadata',
      'crop',
      'resize',
      'audioAnno',
      'videoAnno',
      'videoSnip',
      'relateUMOs',
      'imageAnno',
      'mediaPopulate',
      'metaCopy',
    ],
    workspaceMenu: [
      'exportXLS',
      'exportAllToXLS',
      'exportPPT',
      'exportZIP',
      'exportPDF',
      'batchDownload',
      'saveToDropbox',
      'usageBasket',
      'photoBasket',
      'email',
      'relateUMOs',
      'resizeAll',
      'shareAsPortal',
      'shareExternalPortal',
    ],
    categorySpannerMenu: ['subCategory', 'edit', 'move', 'upload', 'sort'],
    customWorkspaceMenu: false,
    formsMenu: {
      enabled: false,
      options: {
        mediaRequest: {
          name: 'JOB.Basket Media Asset Request',
          label: 'External Media Request Form',
          labelLocale: {
            en: 'External Media Request Form',
            fr: 'FR External Media Request Form',
          },
        },
        eventRequest: {
          name: 'JOB.Basket Photo Event Request',
          label: 'Events Request Form',
          labelLocale: {
            en: 'Events Request Form',
            fr: 'FR Events Request Form',
          },
        },
      },
    },
    reportsMenu: ['editHistory', 'downloadList', 'userProfile'],
  },
  advanced: {
    zoomifyMetatag: false,
    audioAnnotationMetatag: false,
    mediaPopulateDescMetatag: false,
    enableCCListEdit: true,
    maxDirectDownloadItems: 200,
    allowRecycleBinPurge: false,
    allowCropRatios: false,
    metaCopyMaxItems: 20,
    disableAdvancedSearchCollectionRestriction: true,
  },
  advancedCropSettings: {
    cropRatioOptions: [{ name: 'None', ratio: ''}, {name: '1/1', ratio: "1/1"}, {name: '16/9', ratio: "16/9"},
      {name: '2180x1296', dimensions: '2180x1296'},
      {name: '1920x1080', dimensions: '1920x1080'},
      {name: '1280x720', dimensions: '1280x720'},
      {name: '640x480', dimensions: '640x480'},
      {name: '320x240', dimensions: '320x240', resizable: true},
    ],
    metaOptions: {
      displayMetatags: [],
      autoUpdateDateMetatag: '',
    },
    cropAlternateCategoryName: '',
    cropAID: '',
    cropAlternateMetatag: '',
    downloadCropImage: false,
    useWebQualityOnly: false,
  },
  advancedPDFSettings: false, /*{
    mainPDFTitle: 'Export to General PDF',
    additionalPDFLinks: [{title: 'Export to Press PDF', templateName: 'PRESS'}],
    restrictOnePerPage: false,
  },*/

  displayDisclaimer: false,
  disclaimerMessage:
    'Upon Using this Service, you agree to our terms and services',
  welcomeMessage: false,
  sensitiveContentDisclaimerMessage: 'CONTENT WARNING: The following contains historic content/images users may find upsetting or offensive.',
  fileUploader: {
    uploadType: 'BATCH',
    timeDelay: 2000,
    batchSize: 2,
    maxTotalFilesSize: 2147483648,
    maxNoOfFiles: 50,
  },
  isDragSelectionEnabled: false,
};

/**
 * @param {{appConfig:string}} config file
 */
try {
  if (appConfig) {
    Object.assign(config, appConfig); // Global variable from custom app config.
  }
} catch (e) {
} finally {
  // this will store the default remote config merged with the local config
  // it will be used to revert back to if appConfig gets overwritten with the user defined config
  defaultConfig = JSON.parse(JSON.stringify(config));
}

export function updateConfig(data = {}) {
  Object.assign(config, data);
}

export function resetConfig() {
  // config gets reset in this manner -- manually deletion of keys and then merged/assigned --
  // with the default so we keep the same object. if we assign a new object, the config being
  // imported into the other files won't be updated.
  Object.keys(config).forEach((key) => {
    delete config[key];
  });
  Object.assign(config, JSON.parse(JSON.stringify(defaultConfig)));
}

export default config;
